// @vendors
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';

// @components
import FooterAdvice from './../components/FooterAdvice/FooterAdvice'

// @utilities
const { FormattedText } = require('core/i18n').i18n;
import { recordLink,
    PROC_AGGREGATOR,
    PROC_INSERT_OTP_FROM_ADVICE,
    PROC_INSERT_OTP_CLOSE_ADVICE,
} from 'utilities/tagging';

class AggregatorSecondPhaseAdvise extends Component {

    handleButtonClick = () => {
        const { bankId, genericMessage, history } = this.props;
        if (genericMessage) {
            history.push(`/myprofile/global/entities/manage`)
        } else {
            recordLink(PROC_AGGREGATOR, PROC_INSERT_OTP_FROM_ADVICE)
            history.push(`/myprofile/global/entities/manage/credentials/${bankId}`)
        }
    }

    handleOnCloseAdvice = () => {
        recordLink(PROC_AGGREGATOR, PROC_INSERT_OTP_CLOSE_ADVICE)
    }

    render() {
        const { bankName, genericMessage } = this.props;
        const messageTitle = `aggregatorStatus-${genericMessage ? 'genericTitle' : 'secondFactorAuthTitle'}`;
        const messageDescription = `aggregatorStatus-${genericMessage ? 'genericDescription' : 'secondFactorAuthDescription'}`;
        const messageButton = `aggregatorStatus-${genericMessage ? 'genericPrimaryButton' : 'secondFactorAuthPrimaryButton'}`;

        return (
            <FooterAdvice
                title={<FormattedText value={messageTitle} injectedStrings={[bankName]}/>}
                description={<FormattedText value={messageDescription} injectedStrings={[bankName]}/>}
                textButton={<FormattedText value={messageButton} />}
                onClickButton={this.handleButtonClick}
                onCloseCallback={this.handleOnCloseAdvice}
            />
        )
    }
}

AggregatorSecondPhaseAdvise.propTypes = {
    bankId: PropTypes.string,
    bankName: PropTypes.string,
    deprecated: PropTypes.bool,
    genericMessage: PropTypes.bool,
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorSecondPhaseAdvise);
